import { v4 as uuidv4 } from "uuid";
import { generateStaticQuestionId } from "../../../../../utils/goalsUtils";

export const coaching = {
    "blockId": uuidv4(),
    "description": "<p>Grow Your Talent: Scale capacity by maximizing the performance and potential of future talent through coaching- creating a space for others to grow, conducting meaningful conversations that are based on inclusive, trustworthy, empowering relationships.</p>",
    "goalId": "dynamic360Strength",
    isRequired: true,
    feedbackBasedCondition: [
        {
            answeringCondition: [
                {
                    columnValues: ["1", "2"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["3", "4"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["5", "6"],
                    numberOfAnswersNeeded: 3,
                }
            ]
        }

    ],
    allowNAOption: true,
    "questions": [
        {
            "question": "",
            "options": [
                {
                    "label": "Never",
                    "value": "1"
                },
                {
                    "label": "Rarely",
                    "value": "2"
                },
                {
                    "label": "Occasionally",
                    "value": "3"
                },
                {
                    "label": "Sometimes",
                    "value": "4"
                },
                {
                    "label": "Usually",
                    "value": "5"
                },
                {
                    "label": "Always",
                    "value": "6"
                },
                { "label": "Can't answer", "value": "0" }
            ],
            "questionDimension": "Custom Matrix",
            "type": "matrix",
            "qid": uuidv4(),
            "matrixQuestions": [
                {
                    "subCategoryId": generateStaticQuestionId("Drive High Velocity Performance"),
                    "subCategory": "Drive High Velocity Performance ",
                    "staticQuestionId": generateStaticQuestionId("Sets clear expectations to achieve business objectives"),
                    "HTMLText": "<p>Sets clear expectations to achieve business objectives</p>",
                    "isSelected": true,
                    "text": "Sets clear expectations to achieve business objectives",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Drive High Velocity Performance"),
                    "subCategory": "Drive High Velocity Performance ",
                    "staticQuestionId": generateStaticQuestionId("Provides timely coaching to support team members' personal and professional growth"),
                    "HTMLText": "<p>Provides timely coaching to support team members' personal and professional growth</p>",
                    "isSelected": true,
                    "text": "Provides timely coaching to support team members' personal and professional growth",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Drive High Velocity Performance"),
                    "subCategory": "Drive High Velocity Performance ",
                    "staticQuestionId": generateStaticQuestionId("Holds individual team members accountable for achieving high quality results"),
                    "HTMLText": "<p>Holds individual team members accountable for achieving high quality results</p>",
                    "isSelected": true,
                    "text": "Holds individual team members accountable for achieving high quality results",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Optimize Talent Potential"),
                    "subCategory": "Optimize Talent Potential",
                    "staticQuestionId": generateStaticQuestionId("Accurately identifies the strengths and development needs of team members"),
                    "HTMLText": "<p>Accurately identifies the strengths and development needs of team members</p>",
                    "isSelected": true,
                    "text": "Accurately identifies the strengths and development needs of team members",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Optimize Talent Potential"),
                    "subCategory": "Optimize Talent Potential",
                    "staticQuestionId": generateStaticQuestionId("Provides assignments that stretch and grow team members"),
                    "HTMLText": "<p>Provides assignments that stretch and grow team members</p>",
                    "isSelected": true,
                    "text": "Provides assignments that stretch and grow team members",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Optimize Talent Potential"),
                    "subCategory": "Optimize Talent Potential",
                    "staticQuestionId": generateStaticQuestionId("Provides team members with honest, clear, and actionable feedback to drive business outcomes"),
                    "HTMLText": "<p>Provides team members with honest, clear, and actionable feedback to drive business outcomes</p>",
                    "isSelected": true,
                    "text": "Provides team members with honest, clear, and actionable feedback to drive business outcomes",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Build Employee Engagement"),
                    "subCategory": "Build Employee Engagement",
                    "staticQuestionId": generateStaticQuestionId("Adapts management style and behaviors based on the situation and needs of team members"),
                    "HTMLText": "<p>Adapts management style and behaviors based on the situation and needs of team members</p>",
                    "isSelected": true,
                    "text": "Adapts management style and behaviors based on the situation and needs of team members",
                    "value": uuidv4()
                },
              
                {
                    "subCategoryId": generateStaticQuestionId("Build Employee Engagement"),
                    "subCategory": "Build Employee Engagement",
                    "staticQuestionId": generateStaticQuestionId("Encourages team members to take initiative in determining how best to get their work done"),
                    "HTMLText": "<p>Encourages team members to take initiative in determining how best to get their work done</p>",
                    "isSelected": true,
                    "text": "Encourages team members to take initiative in determining how best to get their work done",
                    "value": uuidv4()
                },
             
                {
                    "subCategoryId": generateStaticQuestionId("Build Employee Engagement"),
                    "subCategory":"Build Employee Engagement",
                    "staticQuestionId": generateStaticQuestionId("Demonstrates care and empathy for employee well-being while driving business results"),
                    "HTMLText": "<p>Demonstrates care and empathy for employee well-being while driving business results</p>",
                    "isSelected": true,
                    "text": "Demonstrates care and empathy for employee well-being while driving business results",
                    "value": uuidv4()
                },

              
              
               
            ],
            "questionLabel": "Custom Matrix"
        }
    ],
    "isSelected": true,
    "type": "matrix",
    "dimension": "Coaching"
}